<template>
  <OverlayPanel
    ref="drop"
    :pt="{
      content: {
        class: 'p-0 dark:bg-slate-900'
      }
    }"
    class="dark:before:border-b-white/5 dark:after:border-b-slate-900"
  >
    <div :class="class">
      <slot></slot>
    </div>
  </OverlayPanel>
</template>


<script>

import OverlayPanel from 'primevue/overlaypanel';

export default {
  name: "RpmDrop",
  components: {
    OverlayPanel
  },
  props: {
    class: {
      type: [String, Array, Object],
      default: ''
    }
  }
};
</script>
